import ImageWithPlaceholder from '../../dashboard/components/ImageWithPlaceholder'
import { useTranslation } from 'react-i18next'

const ArchiveItem = ({ archive, url, imgUrl, openBigImage, icon, label, answerClassName, answerTextClassName, time }) => {
    const { t } = useTranslation()
    return (
        <div className="w-full p-5 my-2 flex flex-col gap-[10px] bg-containerGray rounded-[10px] border border-lightPurpleGray">
            <div className="w-full flex flex-row gap-[10px]">
                {imgUrl && (
                    <div className="image-container-new" onClick={() => openBigImage(imgUrl)}>
                        <ImageWithPlaceholder fill minHeight={55} src={`${url}${url.includes('https') ? '&width=450' : ''}`} />
                    </div>
                )}
                <div className="w-full">
                    <div className="flex flex-row items-center">
                        {icon}
                        <p className="ml-[5px] text-[14px] text-mudPurple">{label}</p>
                        <div className="flex-1"></div>
                        <div className="text-[14px] text-mudPurple opacity-60 mr-[5px]">{t('time')}: </div>
                        <div className="text-[14px] text-mudPurple">{time}</div>
                    </div>
                    <div className="mt-[10px] text-[16px] font-bold text-darkPurple">{archive.content?.title}</div>
                    <div className="mt-[10px] text-[16px] font-medium text-darkPurple">{archive.content?.message}</div>
                </div>
            </div>
            <div className="mt-[15px]">
                {archive.answers?.map((option, index) => (
                    <div className={answerClassName} key={index}>
                        <p className={answerTextClassName}>{option}</p>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default ArchiveItem
